module.exports = __webpack_public_path__ + "img/augustus.921f402a.png";